module.exports = __webpack_public_path__ + "static/media/trivvy-draft.354340ca.png";